// The loading, error and message blocks the two access screens share, in the same styling as Unmatched replies.
export const buttonBase = 'inline-flex items-center justify-center rounded-lg px-4 min-h-[44px] text-sm font-medium transition-colors duration-100 disabled:opacity-50 disabled:cursor-not-allowed'
export const primary = `${buttonBase} bg-(--accent) text-(--accent-foreground) hover:bg-(--accent-hover)`
export const quiet = `${buttonBase} border border-(--border) text-(--foreground) hover:bg-(--muted)`

export function Panel({ children, role, label, ...rest }) {
  return <div role={role} aria-label={label} className="glass-panel rounded-2xl p-5 sm:p-6" {...rest}>{children}</div>
}

export function LoadingPanel({ text }) {
  return <Panel role="status" label={text} data-state="loading"><p className="text-sm text-(--muted-foreground)">{text}</p></Panel>
}

export function ErrorPanel({ text, onRetry }) {
  return (
    <div role="alert" data-state="error" className="rounded-xl p-4 border border-(--error)/20 bg-(--error-muted) text-sm text-(--error) flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <span>{text}</span>
      {onRetry && <button type="button" className={quiet} onClick={onRetry}>Retry</button>}
    </div>
  )
}

export function MessagePanel({ text, state }) {
  return <Panel data-state={state}><p className="text-sm text-(--foreground)">{text}</p></Panel>
}
